import { Service, signal } from '@angular/core';

export interface Toast {
  text: string;
  type: 'success' | 'danger' | 'warning' | 'info';
  delay: number;
  html?: boolean;
}

const DEFAULT_DELAY: Record<Toast['type'], number> = {
  success: 5000,
  info: 5000,
  warning: 10000,
  danger: 10000,
};

@Service()
export class ToastService {
  toasts = signal<Toast[]>([]);

  show = (toast: Pick<Toast, 'text'> & Partial<Omit<Toast, 'text'>>) => {
    const withoutDuplicates = this.toasts().filter(
      (existingToast) => existingToast.text !== toast.text
    );
    const type = toast.type ?? 'info';
    const completeToast = {
      ...toast,
      type,
      delay: toast.delay ?? DEFAULT_DELAY[type],
    };

    this.toasts.set([...withoutDuplicates, completeToast]);
  };

  showDanger = (text: string) => {
    this.show({ text, type: 'danger' });
  };

  remove = (toast: Toast) => {
    this.toasts.update((toasts) => toasts.filter((t) => t !== toast));
  };

  clear = () => {
    this.toasts.set([]);
  };
}
